/**
 * Masthead: the paper's name on a rough-globe plinth, edition line,
 * and the nav. The motto plate is intentionally NOT rendered — rule 9
 * keeps the standing motto out of the artifact; the masthead carries
 * the edition tagline instead.
 */

import { EDITION } from "./data";

export function renderMasthead(host: HTMLElement): void {
  host.innerHTML = `
  <header class="wire-masthead">
    <div class="wire-masthead__rule" data-ws-divider></div>
    <div class="wire-masthead__row">
      <a class="wire-masthead__home" href="#front" data-nav="front">
        <span class="wire-masthead__globe" data-ws-globe aria-hidden="true"></span>
        <h1 class="wire-masthead__title">The Ordinary Wire</h1>
      </a>
      <nav class="wire-nav" aria-label="Sections">
        <button class="wire-nav__item" type="button" data-nav="front">Front page</button>
        <button class="wire-nav__item" type="button" data-nav="editions">Editions</button>
        <button class="wire-nav__item" type="button" data-nav="archive">Archive</button>
        <button class="wire-nav__item wire-nav__item--cta" type="button" data-nav="signup">Sign up</button>
      </nav>
    </div>
    <div class="wire-masthead__meta">
      <span>${EDITION.tagline}</span>
      <span>${EDITION.number} · ${EDITION.date}</span>
    </div>
    <div class="wire-masthead__rule" data-ws-divider></div>
  </header>`;
}
